import React from 'react';
import { Button } from './ui/button';
import { CheckCircle2, Sparkles, Calendar, Shield } from 'lucide-react';

const TreeWrapping = () => {
  const features = [
    { icon: <CheckCircle2 className="text-blue-400" />, text: 'Professional installation up to 60ft tall' },
    { icon: <Sparkles className="text-blue-400" />, text: 'Custom lighting designs for any tree size' },
    { icon: <Calendar className="text-blue-400" />, text: 'Year-round or seasonal options available' },
    { icon: <Shield className="text-blue-400" />, text: 'Weather-resistant, durable materials' }
  ];

  const scrollToQuote = () => {
    document.getElementById('quote').scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToPricing = () => {
    document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="tree-wrapping" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/elv9kxmw_482224646_680807304465040_3188358540127725233_n.jpg"
              alt="Professional tree wrapping with lights"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">Professional Tree Wrapping</h2>
            <p className="text-xl text-gray-600 mb-8">
              Transform your landscape with expertly wrapped tree lighting. Our professional installers handle trees up to 60ft tall, creating stunning visual displays that enhance your property's beauty throughout the year.
            </p>

            <div className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="mt-1">{feature.icon}</div>
                  <p className="text-gray-700 text-lg">{feature.text}</p>
                </div>
              ))}
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-blue-400 mb-8">
              <p className="text-gray-800 text-lg">
                <strong className="text-blue-600">Expert Installation:</strong> Our team uses specialized equipment and techniques to safely wrap trees of any height, ensuring a professional finish that lasts.
              </p>
            </div>

            <Button onClick={scrollToPricing} size="lg" className="bg-blue-500 hover:bg-blue-600 text-white font-bold px-8">
              Tree Wrapping Pricing
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreeWrapping;
